<template>
  <button
    class="ml-icon-button"
    :class="[`ml-icon-button-${variant}`, { disabled }]"
    @click.prevent="$emit('click')"
    :disabled="disabled"
  >
    <span class="svg-icon svg-icon-md icon-inherit mr-2">
      <i v-if="icon" :class="icon"></i>
      <inline-svg v-if="svg" :src="svg" fill="currentColor"></inline-svg>
    </span>
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'MemlistIconButton',
  emits: ['click'],
  props: {
    icon: {
      type: String,
      default: null
    },
    svg: {
      type: String,
      default: null
    },
    text: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'primary',
      validator: v =>
        ['primary', 'primary-outline', 'success', 'success-outline', 'danger', 'danger-outline','secondary'].includes(v)
    },
      disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.ml-icon-button {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ml-icon-button-primary {
  background-color: #3699FF;
  color: #fff;
}
.ml-icon-button-primary:hover {
  background-color: #277dd3;
}

.ml-icon-button-primary-outline {
  background-color: transparent;
  color: #3699FF;
  border-color: #3699FF;
}
.ml-icon-button-primary-outline:hover {
  background-color: #e6f0ff;
}

.ml-icon-button-success {
  background-color: #1BC5BD;
  color: #fff;
}
.ml-icon-button-success:hover {
  background-color: #22dad0;
}

.ml-icon-button-success-outline {
  background-color: transparent;
  color: #1BC5BD;
  border-color: #1BC5BD;
}
.ml-icon-button-success-outline:hover {
  background-color: #e6f9ed;
}

.ml-icon-button-danger {
  background-color: #fd397a;
  color: #fff;
}
.ml-icon-button-danger:hover {
  background-color: #fd397a;
}

.ml-icon-button-danger-outline {
  background-color: transparent;
  color: #fd397a;
  border-color: #fd397a;
}
.ml-icon-button-danger-outline:hover {
  background-color: #fd397a;
}

.icon-inherit {
  font-size: 1em;
  display: inline-flex;
  align-items: center;
}
.ml-icon-button i {
  color: inherit;
}
/* Secondary */
.ml-icon-button-secondary {
  background-color: #d9d9d9;
  color: #2b2b2b;
}
.ml-icon-button-secondary:hover:not(:disabled) {
  background-color: #eeeeee;
}
.ml-icon-button:disabled,
.ml-icon-button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
